import { openComponentInPopup, QueryParameter } from './common';
import { IPopup, PopupOptions } from './popup';

export default class ConfirmDialog {
    private onClickOk: () => void;
    private onClickCancel: () => void;
    private popup: IPopup;

    constructor(onClickOk: () => void, onClickCancel?: () => void) {
        this.onClickOk = onClickOk;
        this.onClickCancel = onClickCancel;
    }

    async open(queryParam: QueryParameter[] = null): Promise<void> {
        this.popup = await openComponentInPopup('ConfirmDialog', queryParam, <
            PopupOptions
        >{ id: 'confirm-popup' });
        this.subscribeOkButton();
        this.subscribeCancelButton();
    }

    private subscribeOkButton(): void {
        this.subscribeOption('true', () => {
            typeof this.onClickOk === 'function' && this.onClickOk();
            this.popup.close();
        });
    }

    private subscribeCancelButton(): void {
        this.subscribeOption('false', () => {
            typeof this.onClickCancel === 'function' && this.onClickCancel();
            this.popup.close();
        });
    }

    // The options are href-less anchors with role="button"/tabindex — give them native-like keyboard
    // activation (Enter/Space) alongside the click (same pattern as the TronDesigner start dialog).
    private subscribeOption(option: string, activate: () => void): void {
        const element = document.querySelector<HTMLElement>(
            `[data-component=ConfirmDialog] [data-option=${option}]`
        );
        if (!element) {
            return;
        }

        element.addEventListener('click', activate);
        element.addEventListener('keydown', (evt: KeyboardEvent) => {
            if (evt.key === 'Enter' || evt.key === ' ') {
                evt.preventDefault();
                activate();
            }
        });
    }
}
